<template>
  <div class="water-mark-mask">
    <div class="row" :key="index" v-for="(item, index) in rows">
      <div class="col" :key="index" v-for="(item, index) in cols">
        {{ text }}-{{ mobile }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: ''
    },
    mobile: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      rows: [],
      cols: [],
      color: 'rgba(0,0,0,0.1)'
    };
  },
  mounted() {
    let windowWidth = document.body.clientWidth;
    let windowHeight = document.body.clientHeight;
    const rows = Math.ceil(windowWidth / (40 * 6));
    const cols = Math.ceil(windowHeight / 240);
    this.rows = new Array(rows);
    this.cols = new Array(cols);
  }
};
</script>

<style lang="scss" scoped>
.water-mark-mask {
  position: absolute;
  top: 320px;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  pointer-events: none;
  flex: 1;
  background: #fff;
  z-index: -1;
  overflow-x: hidden;
}

.row {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.col {
  transform: rotate(-45deg);
  height: 300px;
  color: rgba(0, 0, 0, 0.1);
  font-size: 30px;
}
</style>
